import { services } from '../services';
import { clubList } from './lists/clubList';

const clubStore = {
  state: {
    overrideClub: false,
    overridingClubId: 0,
    clubLoaded: false,
    logoUrl: null,
    bannerUrl: null,
    coverUrl: 'cover.jpg',
    lessonSettings: null,
    isAffiliationFeeMandatory: false,
    affiliationFee: 0,
    greenFeeLoyaltyClub: false,
    // null = unknown (old backend / missing field) -> label falls back to the boolean
    membershipLabelType: null,
    // Only sent while the club is inside its run-off period, so this empties itself on the leaving date.
    clubLeavingDate: null,
    isManualBookingOnly: false,
  },

  getters: {
    lessonsEnabled: (state) => {
      const settings = state.lessonSettings;
      return settings && settings.LessonsEnabled;
    },

    homeClubInfo: state => ({
      GreenFeeLoyaltyClub: state.greenFeeLoyaltyClub,
      MembershipLabelType: state.membershipLabelType,
    }),

    clubIsLeavingPartnership: state => state.clubLeavingDate !== null && state.clubLeavingDate !== '',

    getClub: (state, getters, rootState) => {
      if (state.overrideClub) {
        return clubList.find(club => club.clubId === state.overridingClubId) !== undefined
          ? clubList.find(club => club.clubId === state.overridingClubId)
          : clubList.find(club => club.clubId === 0);
      }
      return clubList.find(club => club.clubId === rootState.user.homeClubId) !== undefined
        ? clubList.find(club => club.clubId === rootState.user.homeClubId)
        : clubList.find(club => club.clubId === 0);
    },

    mandatoryAffiliationFee: state => (state.isAffiliationFeeMandatory ? state.affiliationFee : 0),
  },

  mutations: {
    setOverrideStyle(state, value) {
      state.overrideClub = value;
    },

    setOverridingClubId(state, value) {
      state.clubLoaded = false;
      if (!isNaN(value)) {
        state.overridingClubId = Number(value);
        services.club.clubDetails(state.overridingClubId).then((data) => {
          state.logoUrl = data.LogoUrl;
          state.bannerUrl = data.BannerUrl;
          state.coverUrl = data.CoverUrl === null ? `${process.env.VUE_APP_BASE_URL}img/cover.jpg` : data.CoverUrl;
          state.isAffiliationFeeMandatory = !!(data.isAffiliationFeeMandatory || data.IsAffiliationFeeMandatory);
          state.affiliationFee = data.mandatoryAffiliationFee || data.MandatoryAffiliationFee || 0;
          state.greenFeeLoyaltyClub = !!data.GreenFeeLoyaltyClub;
          state.membershipLabelType = typeof data.MembershipLabelType === 'number' ? data.MembershipLabelType : null;
          state.clubLeavingDate = data.ClubLeavingDate || null;
          state.isManualBookingOnly = !!data.IsManualBookingOnly;
          state.clubLoaded = true;
        });
      } else {
        state.overridingClubId = 0;
        state.clubLoaded = true;
      }
    },

    setClubDetails(state, value) {
      state.coverUrl = value.CoverUrl;
      state.bannerUrl = value.BannerUrl;
      state.lessonSettings = value.LessonSettings || null;
      state.isAffiliationFeeMandatory = !!(value.isAffiliationFeeMandatory || value.IsAffiliationFeeMandatory);
      state.affiliationFee = value.mandatoryAffiliationFee || value.MandatoryAffiliationFee || 0;
      state.greenFeeLoyaltyClub = !!value.GreenFeeLoyaltyClub;
      state.membershipLabelType = typeof value.MembershipLabelType === 'number' ? value.MembershipLabelType : null;
      state.clubLeavingDate = value.ClubLeavingDate || null;
      state.isManualBookingOnly = !!value.IsManualBookingOnly;
    },
  },

  actions: {
    getClubDetails(context, value) {
      services.club.clubDetails(value).then((data) => {
        // eslint-disable-next-line no-param-reassign
        data.CoverUrl = data.CoverUrl === null ? 'cover.jpg' : data.CoverUrl;
        context.commit('setClubDetails', data);
      });
    },
  },
};

export { clubStore };
